

























































































































































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import Transaction from '@/models/Accounts/Shared/Transactions/Transaction';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import DebitCreditCode from '@/models/Shared/DebitCreditCode';

@Component({ name: 'WalletsTransactionDetailsDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    dialog = false;
    DebitCreditCode = DebitCreditCode;

    @Prop({ required: true })
    transaction: Transaction;

    @Prop({ required: false })
    isPendingTransactions: boolean;

    async releaseTransaction() {
        this.dialog = false;
        await DepositAccountModule.releasePendingTransaction(this.transaction.transactionId);
    }

    get loading() {
        return DepositAccountModule.loadingTransactions;
    }

    // TODO: This is a workaround until the API returns the balance in an Amount object format
    get formattedBalance() {
        return {
            amount: this.transaction.balance,
            currency: this.transaction.amount ? this.transaction.amount.currency : ""
        }
    }

    // TODO: This is a workaround until the API returns the availableBalance in an Amount object format
    get formattedAvailableBalance() {
        return {
            amount: this.transaction.availableBalance,
            currency: this.transaction.amount ? this.transaction.amount.currency : ""
        }
    }

    get allowManualRelease() {
        // Only allow manual release of pending transactions, and if the transaction is more than 7 days old
        if (this.isPendingTransactions) {
            const currentDate = new Date();
            const transactionCreatedAtDate = new Date(this.transaction.createdAtUtc);
            // Add seven days to the createdAt date for the transaction
            transactionCreatedAtDate.setDate(transactionCreatedAtDate.getDate() + 7);
            // Check that this transaction created at date is still before today
            return transactionCreatedAtDate < currentDate;
        }
        else {
            return false;
        }
    }

    // fees: (transaction.fees === null) ? undefined : transaction.fees,

}
